<div class="common-popup">
  <div class="popup-header">
    <div class="popup-header-main">
      <div class="popup-header-icon">
        <i class="fa-regular fa-calendar"></i>
      </div>
      <div class="header-title-group">
        <h3 class="title">{{ headerTitle }}</h3>
        <small class="subtitle" *ngIf="data?.subTitle">{{ data.subTitle }}</small>
      </div>
    </div>
    <button mat-icon-button type="button" class="popup-close" (click)="close()" aria-label="Close">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <hr class="popup-divider" />

  <div class="body common-popup-content">
    <ng-container *ngIf="data?.template; else htmlContent">
      <ng-container *ngTemplateOutlet="data.template; context: data.context"></ng-container>
    </ng-container>
    <ng-template #htmlContent>
      <div [innerHTML]="data?.html || ''"></div>
    </ng-template>
  </div>

  <hr class="popup-divider footer-divider" *ngIf="data?.actions?.length" />
  <div class="footer" *ngIf="data?.actions?.length">
    <button mat-button *ngFor="let a of data.actions" (click)="a.handler ? a.handler() : close(a.value)">
      {{ a.label }}
    </button>
  </div>
</div>